import { UploadButton } from '@bytescale/upload-widget-react';
import { useTranslation } from 'react-i18next';
import { UploadWidgetLocale, UploadWidgetOnPreUploadResult, UploadWidgetResult } from '@bytescale/upload-widget';
import { AddCircleOutline } from '@mui/icons-material';
import React from 'react';
import Button from '@mui/material/Button';
import { useAuth } from '../../../../session/InternalAuthProvider';
import { AccountData } from '../../../../api';
import { compressImage } from '../../../../utils/compressImage';

type ImageUploadWidgetProps = {
  onImageUpload: (files: UploadWidgetResult[]) => void;
  maxFileCount?: number;
  renderTrigger?: (onClick: React.MouseEventHandler) => React.ReactElement;
};
export const ImageUploadWidget = ({ onImageUpload, maxFileCount = 1, renderTrigger }: ImageUploadWidgetProps) => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const { t } = useTranslation();

  const localeOverride: UploadWidgetLocale = t('bytescaleWidgetOverrides', { returnObjects: true });
  const options = {
    apiKey: import.meta.env.VITE_REACT_APP_BYTESCALE,
    maxFileCount,
    multi: maxFileCount > 1,
    path: {
      // fileName: uuid(),
      fileNameVariablesEnabled: false,
      folderPath: `/uploads/${account.id}`,
      folderPathVariablesEnabled: false,
    },
    locale: localeOverride,
    maxFileSizeBytes: 5 * 1024 * 1024,
    mimeTypes: ['image/*'],
    onPreUpload: async (file: File): Promise<UploadWidgetOnPreUploadResult> => {
      const compressed = await compressImage(file);
      return { transformedFile: compressed };
    },
  };

  return (
    <UploadButton options={options} onComplete={onImageUpload}>
      {({ onClick }) =>
        renderTrigger ? (
          renderTrigger(onClick)
        ) : (
          <Button
            variant="outlined"
            startIcon={<AddCircleOutline />}
            onClick={onClick}
            style={{ textTransform: 'none', width: 'fit-content' }}>
            {t('uploadImage')}
          </Button>
        )
      }
    </UploadButton>
  );
};
